export default __webpack_public_path__ + "static/media/ratingIcon.d9ce9699.png";